import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RecommendationsComponent } from './recommendations.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        TranslateModule,
        SharedModule
    ],
    declarations: [
        RecommendationsComponent
    ]
})

export class RecommendationsModule {

}
